import { motion } from "framer-motion";
import { CONTENT } from "@/content";

const W = CONTENT.home.howItWorks;

export const HowItWorks = () => (
  <section className="how" data-testid="home-how-it-works">
    <span className="pill">{W.label}</span>
    <div className="how-grid">
      {W.steps.map((s, i) => (
        <motion.div
          key={s.title}
          className="nb-card how-card"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.45, delay: i * 0.2 }}
          data-testid={`how-step-${i + 1}`}
        >
          <span className="how-mark" aria-hidden="true">
            {i === 2 && [0, 1, 2].map((r) => <span key={r} className="mini-ripple" style={{ animationDelay: `${r * 0.8}s` }} />)}
            <span className="how-num">{i + 1}</span>
          </span>
          <h3 className="journey-title">{s.title}</h3>
          <p className="journey-text">{s.text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
